import BaseAPI from "../../baseAPI"

class CartAPI extends BaseAPI {
  constructor() {
    super("/store/cart")
  }

  getWithPagination(query) {
    return this.getByQuery("", query, true)
  }

  getOrderCount(query) {
    return this.getByQuery("/order-count", query, true)
  }

  addAndUpdateCart(data) {
    return this.post("/save", data, true)
  }

  toggleCheck(id) {
    return this.post(`/${id}/check`, null, true)
  }

  deleteMultiple(query) {
    return this.deleteByQuery("/deletes", query, true)
  }
}

export { CartAPI as default }